const repaymentPercentage = 0.03;
const miniMumRepayment = 30;

export const calculateMonthlyRepayment = creditLimit => {
  if (creditLimit * repaymentPercentage > miniMumRepayment) {
    return creditLimit * repaymentPercentage;
  }
  return miniMumRepayment;
};
